import { fullMarkdown } from "PFCore/helpers/markdown";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import { prune } from "underscore.string";

import css from "./markdown.less";

const MAX_CROP_MARGIN = 30;

const Markdown = ({ raw, qaId, style, className, crop, onToggle, displayToggle }) => {
  const [revealed, setRevealed] = useState(false);
  const cropMargin = Math.min(crop * 0.15, MAX_CROP_MARGIN);
  const isShort = (raw || "").length < crop + cropMargin;
  const html = useMemo(() => {
    const text = !crop || revealed || isShort ? raw : prune(raw, crop);
    return fullMarkdown(text);
  }, [crop, revealed, raw, isShort]);

  return (
    <div style={style} className={className}>
      <div dangerouslySetInnerHTML={{ __html: html }} data-qa-id={qaId} style={style} className={css.md} />
      {crop && !isShort && (
        <a
          className={css.more}
          onClick={() => {
            setRevealed((val) => !val);
            onToggle && window.setTimeout(onToggle, 1);
          }}
        >
          {displayToggle && (revealed ? "less" : "more")}
        </a>
      )}
    </div>
  );
};

Markdown.defaultProps = {
  raw: "",
  qaId: "Markdown",
  crop: 200,
  displayToggle: true
};

Markdown.propTypes = {
  raw: PropTypes.string,
  qaId: PropTypes.string,
  style: PropTypes.object,
  crop: PropTypes.number,
  className: PropTypes.string,
  onToggle: PropTypes.func,
  displayToggle: PropTypes.bool
};

export default Markdown;
